{
    "DirectoryList_Column_Description": "Descrição",
    "DirectoryList_Column_TelephoneNumber": "Número de telefone",
    "DirectoryList_Add_Disabled_SelectTelSys": "Selecione um servidor de telefonia para adicionar uma entrada de diretório.",
    "DirectoryList_Add_Disabled_NoTelephonyFilter": "Desative o filtro \"sem servidor de telefonia\" para adicionar uma entrada ao diretório.",
    "NAME": "Lista de diretóriosIdioma"
}